module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ChannelAccountMgmtView.jsx"));
	}, "ChannelAccountMgmt");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChannelAccountMgmt!./src/pages/SystemManage/ChannelAccountMgmt/ChannelAccountMgmtView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=ChannelAccountMgmt!./src/pages/SystemManage/ChannelAccountMgmt/ChannelAccountMgmtView.jsx
// module chunks = 43